// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ComponentSubscriptionEditController = function ($scope, $modalInstance, componentSubscriptionId, contract, ComponentSubscription, ComponentSubscriptionEnd, gettextCatalog, gettext, Contract, PUtill) {
    $scope.isNowSelected = false;
    $scope.contract = contract;
    $scope.endSubscription = new ComponentSubscriptionEnd();
    $scope.endSubscription.EndDate = null;
    $scope.isNowDisabled = true;
    $scope.areDatesEqual = PUtill.areDatesEqual;
    
    $scope.setEndDateNow = function () {
        $scope.endSubscription.EndDate = new Date();
        $scope.isNowSelected = true;
    }

    $scope.setEndDate = function (newDate) {
        $scope.isNowSelected = false;
        $scope.endSubscription.EndDate = newDate;
    }

    $scope.getDateToTimeAdjusted = function(date) {
        return Contract.getDateToPhaseStartTimeAdjusted($scope.contract, date);
    };
    
    ComponentSubscription.get({ componentSubscriptionId: componentSubscriptionId }, function (data) {
        if (data.BilledUntil)
            data.BilledUntil = PUtill.normalizeUtc(data.BilledUntil);
        $scope.componentSubscription = data;
        $scope.isNowDisabled = moment($scope.componentSubscription.StartDate).diff(new Date(), 'minutes') > 0;

        if ($scope.isNowDisabled)
            $scope.setEndDate($scope.componentSubscription.StartDate);
        else
            $scope.setEndDateNow();
    });

    $scope.cancel = function () { $modalInstance.close(); };
    $scope.save = function () {
        $scope.componentSubscription.$update({ componentSubscriptionId: componentSubscriptionId }, function () {
            $modalInstance.close();
            $scope.notify("success", gettextCatalog.getString(gettext("Component subscription updated successfully")));
        });
    };
    $scope.end = function () {
        $scope.endSubscription.$save({ contractId: contract.Id, componentSubscriptionId: componentSubscriptionId }, function () {
            $modalInstance.close();
            $scope.notify("success", gettextCatalog.getString(gettext("End of component subscription set successfully")));
        });
    };
    
    $scope.willImmediateBillingBeTriggered = function() {
        if ($scope.componentSubscription)
            return $scope.componentSubscription.BilledUntil && moment($scope.componentSubscription.BilledUntil).diff($scope.endSubscription.EndDate, 'minutes') > 0;
    };

};
ComponentSubscriptionEditController.$inject = ['$scope', '$uibModalInstance', 'componentSubscriptionId', 'contract', 'ComponentSubscription', 'ComponentSubscriptionEnd', 'gettextCatalog', 'gettext', 'Contract', 'PUtill'];
